const id_master_division = {
    "": "grup pengguna",
    add: "tambah grup pengguna",
    edit: "ubah grup pengguna",
    view: "detail grup pengguna",

    label: {
        name: 'nama grup',
        user_btn_add: 'tambah pengguna',
        user_title: 'daftar pengguna',
    },

    success: {
        create: 'Berhasil membuat grup pengguna',
        edit: 'Berhasil mengubah grup pengguna',
    },

    error: {
        name: 'nama grup tidak boleh kosong',

        create: 'Gagal membuat grup pengguna',
        edit: 'Gagal mengubah grup pengguna',
    },
}

export default id_master_division;